var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86328 0.875C12.1992 0.875 15.7266 4.31445 15.7266 8.65039C15.7266 9.61133 15.5215 10.6602 15.1523 11.6035H15.1582L15.123 11.6738C15.0937 11.7383 15.0645 11.8027 15.0352 11.8672L7.86328 27.125L0.726563 11.9434L0.691408 11.873C0.662111 11.8086 0.626952 11.7441 0.597656 11.6738L0.57422 11.6094C0.193361 10.666 -1.43051e-06 9.66992 -1.43051e-06 8.66211C-1.43051e-06 4.31445 3.52734 0.875 7.86328 0.875ZM7.86328 11.123C9.38086 11.123 10.6113 9.89258 10.6113 8.375C10.6113 6.85742 9.38086 5.62695 7.86328 5.62695C6.3457 5.62695 5.11523 6.85742 5.11523 8.375C5.11523 9.89258 6.3457 11.123 7.86328 11.123Z",
    fill: "#1E90AA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.716ed5509aaf7096190ae6ecba2070d8.svg";